import DoubleRow from './DoubleRow';

export default DoubleRow;
